import { useNavigate } from 'react-router-dom';
import { APPOINTMENT_CARDS } from './appointmentData';
import { GoArrowRight } from "react-icons/go";

export default function ScheduleAppointmentSection() {

  const navigate = useNavigate();

  return (
    <section id="appointment" className="relative overflow-hidden hero-vedic py-16 md:py-24 md:px-18 text-white">
      <div className="pointer-events-none absolute inset-0 opacity-[0.05] bg-[radial-gradient(#E6C878_1px,transparent_1.5px)] bg-size-[26px_26px]" />
      <div className="container relative z-10 mx-auto px-6 max-w-350">
        <div className="mx-auto mb-10 flex max-w-2xl flex-col items-center text-center">
          <div className="flex items-center gap-3">
            <span className="h-px w-8 bg-secondary/50" />
            <span className="text-[10px] uppercase tracking-[0.4em] text-secondary">Direct Booking</span>
            <span className="h-px w-8 bg-secondary/50" />
          </div>
          <h2 className="mt-3 font-cinzel text-3xl uppercase leading-tight text-[#FBF3E4] md:text-4xl lg:text-5xl">
            Schedule Your <span className="text-gradient-gold">Appointment</span>
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-white/55 md:text-base normal-case">
            Select a spiritual domain to begin your high-precision consultation with Astrologer Raju Maharaj Ji.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
          {APPOINTMENT_CARDS.map((card) => (
            <button
              key={card.n}
              type="button"
              onClick={() => navigate("consultations")}
              className="group relative flex flex-col items-center overflow-hidden rounded-2xl border border-white/10 bg-white/4 p-5 text-center backdrop-blur-sm transition-all duration-400 hover:-translate-y-1.5 hover:border-secondary/45 hover:bg-white/6 cursor-pointer"
            >
              <span className="absolute inset-x-0 top-0 h-1 bg-linear-to-r from-secondary/0 via-secondary/70 to-secondary/0 opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
              <span className="pointer-events-none absolute -right-1 top-2 font-cinzel text-6xl text-white/5 group-hover:text-secondary/20">{card.n}</span>
              <span className="relative grid h-14 w-14 place-items-center rounded-xl bg-secondary/12 text-secondary ring-1 ring-secondary/25 transition-all duration-400 group-hover:bg-secondary group-hover:text-primary">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-5 w-5">
                  {card.circle && <circle cx="12" cy="12" r="4" />}
                  {card.rect && <rect width={card.rect.width} height={card.rect.height} x={card.rect.x} y={card.rect.y} rx={card.rect.rx} />}
                  {card.circleUser && <circle cx={card.circleUser.cx} cy={card.circleUser.cy} r={card.circleUser.r} />}
                  <path d={card.icon} />
                </svg>
              </span>
              <h3 className="relative z-10 mt-4 font-cinzel text-base leading-tight text-[#FBF3E4] group-hover:text-secondary">{card.title}</h3>
              <p className="relative z-10 mt-1.5 text-[12px] leading-relaxed text-white/55">{card.desc}</p>
              <span className="relative z-10 mt-3 inline-flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-widest text-secondary opacity-0 group-hover:opacity-100">
                Book Appointment <GoArrowRight size={20} />
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  )
}
